var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 120,
    viewBox: "0 0 600 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 80)",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Brush Script MT, cursive",
    fontSize: 80,
    fill: "#D32F2F"
  }, "Randeva"), /*#__PURE__*/React.createElement("text", {
    x: 2,
    y: 28,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 20,
    fill: "#334155"
  }, "Advisory Services Pvt Ltd."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg2.5b788d0eb282cbb83fcea77138679292.svg";
export { ForwardRef as ReactComponent };